var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaneIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_3907_544)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "#3DCBB1",
    fillOpacity: 0.68
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.344828 20C0.344828 9.14475 9.14475 0.344828 20 0.344828C30.8553 0.344828 39.6552 9.14475 39.6552 20C39.6552 30.8553 30.8553 39.6552 20 39.6552C9.14475 39.6552 0.344828 30.8553 0.344828 20Z",
    stroke: "white",
    strokeOpacity: 0.23,
    strokeWidth: 0.689655
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3907_544)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4455 16.5542L18.1654 20.2201L12.6428 18.3789C12.2573 18.2502 11.9976 17.8885 11.9998 17.4822C12.002 17.0758 12.2647 16.7164 12.6517 16.5921L26.7713 12.0451C27.1069 11.9372 27.4753 12.0257 27.7246 12.2751C27.9739 12.5244 28.0625 12.8927 27.9546 13.2284L23.4075 27.348C23.2833 27.735 22.9238 27.9976 22.5175 27.9999C22.1112 28.0021 21.7495 27.7424 21.6207 27.3569L19.7706 21.8075L23.4455 16.5542Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_3907_544",
    x: -13.7931,
    y: -13.7931,
    width: 67.5862,
    height: 67.5862,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.89655
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_3907_544"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_3907_544",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3907_544"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneIcon);
export default __webpack_public_path__ + "static/media/plane-icon.813c0aeef2170bd757a049ca8f4e084b.svg";
export { ForwardRef as ReactComponent };